<template>
  <div id="app">
    <header class="header">
      <div class="nav-container">
        <div class="logo" @click="$router.push('/')">爱谱乐医疗</div>
        <nav class="nav-links">
          <router-link to="/">首页</router-link>
          <router-link to="/products">产品&解决方案</router-link>
          <router-link to="/cases">项目案例</router-link>
          <router-link to="/news">新闻动态</router-link>
          <router-link to="/contact">联系我们</router-link>
        </nav>
        <div class="mobile-toggle" @click="toggleMobileNav">☰</div>
      </div>
      <div class="mobile-nav" v-if="mobileNavOpen">
        <router-link to="/" @click="closeNav">首页</router-link>
        <router-link to="/products" @click="closeNav">产品&解决方案</router-link>
        <router-link to="/cases" @click="closeNav">项目案例</router-link>
        <router-link to="/news" @click="closeNav">新闻动态</router-link>
        <router-link to="/contact" @click="closeNav">联系我们</router-link>
      </div>
    </header>
    <main>
      <router-view />
    </main>
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-brand">
          <div class="logo">爱谱乐医疗</div>
          <p>专注手术室智慧物资管理，为医疗健康赋能</p>
        </div>
        <div class="footer-links">
          <div class="link-group">
            <h4>快速链接</h4>
            <router-link to="/products">产品中心</router-link>
            <router-link to="/cases">项目案例</router-link>
            <router-link to="/news">新闻动态</router-link>
          </div>
          <div class="link-group">
            <h4>联系我们</h4>
            <p>📞 xxx-xxx-xxxx</p>
            <p>📧 contact@aipule.com</p>
            <p>📍 苏州工业园区新发路27号C幢5楼</p>
          </div>
        </div>
      </div>
      <div class="copyright">
        <p>© 苏州爱谱乐智能医疗科技有限公司 版权所有 | 
<a href="http://beian.miit.gov.cn" target="_blank" style="color: #cbd5e1;">苏ICP备20046327号-1</a>
</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobileNavOpen: false
    };
  },
  methods: {
    toggleMobileNav() {
      this.mobileNavOpen = !this.mobileNavOpen;
    },
    closeNav() {
      this.mobileNavOpen = false;
    }
  }
};
</script>

<style>
/* 全局重置 & 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', Roboto, 'Helvetica Neue', sans-serif;
  background-color: #ffffff;
  color: #1e293b;
  line-height: 1.5;
  scroll-behavior: smooth;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* 导航栏 (参照 vinno 简约白底悬浮感) */
.header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border-bottom: 1px solid #eef2f6;
}

.nav-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 32px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  font-size: 1.6rem;
  font-weight: 700;
  background: linear-gradient(135deg, #0f5c6e, #1f8aad);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  cursor: pointer;
  letter-spacing: -0.5px;
}

.nav-links {
  display: flex;
  gap: 2.5rem;
}

.nav-links a {
  text-decoration: none;
  font-weight: 500;
  color: #2c3e50;
  transition: 0.2s;
  font-size: 1rem;
  position: relative;
}

.nav-links a:hover {
  color: #1f8aad;
}

.nav-links a.router-link-active {
  color: #1f8aad;
}

.nav-links a.router-link-active::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #1f8aad;
  border-radius: 2px;
}

.mobile-toggle {
  display: none;
  font-size: 1.8rem;
  cursor: pointer;
  user-select: none;
}

.mobile-nav {
  display: none;
  flex-direction: column;
  background: white;
  padding: 1rem 2rem;
  gap: 1rem;
  border-top: 1px solid #eef2f6;
}

.mobile-nav a {
  text-decoration: none;
  color: #2c3e50;
  font-weight: 500;
  padding: 0.5rem 0;
}

/* 页脚 */
.footer {
  background: #0f2b36;
  color: #cbd5e1;
  margin-top: 4rem;
}

.footer-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 3rem 32px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 2rem;
}

.footer-brand .logo {
  font-size: 1.5rem;
  background: linear-gradient(135deg, #7ab7cc, #a0d0e0);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  margin-bottom: 0.8rem;
}

.footer-links {
  display: flex;
  gap: 4rem;
  flex-wrap: wrap;
}

.link-group h4 {
  color: white;
  margin-bottom: 1rem;
  font-weight: 600;
}

.link-group a, .link-group p {
  display: block;
  color: #cbd5e1;
  text-decoration: none;
  margin-bottom: 0.6rem;
  transition: 0.2s;
}

.link-group a:hover {
  color: #7ab7cc;
}

.copyright {
  text-align: center;
  padding: 1.5rem 32px;
  border-top: 1px solid #1e4a5c;
  font-size: 0.8rem;
}

/* 响应式 */
@media (max-width: 768px) {
  .nav-links {
    display: none;
  }
  .mobile-toggle {
    display: block;
  }
  .mobile-nav {
    display: flex;
  }
  .footer-container {
    flex-direction: column;
  }
  .footer-links {
    flex-direction: column;
    gap: 1.5rem;
  }
}
</style>